import { render, staticRenderFns } from "./CatalogManagement.vue?vue&type=template&id=36de5a49&"
import script from "./CatalogManagement.vue?vue&type=script&lang=js&"
export * from "./CatalogManagement.vue?vue&type=script&lang=js&"
import style0 from "./CatalogManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports